import styled from 'styled-components';

export const StyledSVG = styled.svg`
  display: inline-block;
  vertical-align: middle;
  path {
    fill: ${props => props.color};
  }
`;
export default {};
